import React, { useState, useEffect } from 'react';

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('pwa-install-dismissed')) {
      setDismissed(true);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setDeferredPrompt(null);
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem('pwa-install-dismissed', '1');
  };

  if (!deferredPrompt || dismissed) return null;

  return (
    <div className="install-prompt">
      <div className="install-prompt-content">
        <span className="install-prompt-icon">📲</span>
        <div className="install-prompt-text">
          <strong>Adicionar à tela inicial</strong>
          <span>Acesse rapidamente os preços de combustíveis</span>
        </div>
        <button className="btn btn-primary install-prompt-btn" onClick={handleInstall}>
          Instalar
        </button>
        <button className="install-prompt-close" onClick={handleDismiss} aria-label="Fechar">
          ✕
        </button>
      </div>
    </div>
  );
}
